










import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import { GanttChartData } from '@/model/dashboard/GanttChartData'
import { DashboardGanttEmployeeList } from '@/types'

am4core.useTheme(am4themes_animated)

interface ComponentData {
  chart: any
}

export default Vue.extend({
  name: 'GanttChart',

  props: {
    ganttLabel: String,
    ganttChartData: {
      type: Array as () => Array<GanttChartData>
    },
    employees: {
      type: Array as () => DashboardGanttEmployeeList
    },
    ganttDate: String
  },

  data (): ComponentData {
    return {
      chart: undefined
    }
  },

  methods: {
    createChart (): any {
      //@ts-ignore
      let chart = am4core.create(this.$refs.ganttChart, am4charts.XYChart)
      chart.hiddenState.properties.opacity = 0 // this creates initial fade-in

      chart.paddingRight = 30
      chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd HH:mm'

      chart.data = this.employees
      const data = this.ganttChartData

      let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = 'name'
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.inversed = true
      categoryAxis.renderer.minGridDistance = 20

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis())
      dateAxis.dateFormatter.dateFormat = 'yyyy-MM-dd HH:mm'
      dateAxis.renderer.minGridDistance = 2
      dateAxis.baseInterval = { count: 2, timeUnit: 'hour' }
      dateAxis.min = data[0] ? new Date(data[0].fromDate).setHours(0, 1) : ''
      dateAxis.max = data[0] ? new Date(data[0].toDate).setHours(23, 59) : ''
      dateAxis.strictMinMax = true
      dateAxis.renderer.labels.template.rotation = -65
      dateAxis.renderer.labels.template.verticalCenter = 'middle'
      dateAxis.renderer.labels.template.horizontalCenter = 'right'

      function createSeries (field: string, name: string): any {

        if (name === 'shift') {
          let series1 = chart.series.push(new am4charts.ColumnSeries())
          series1.name = name
          series1.columns.template.height = am4core.percent(100)
          series1.columns.template.tooltipText = '{name}: [bold]{label}'
          series1.dataFields.openDateX = 'fromDate'
          series1.dataFields.dateX = 'toDate'
          series1.dataFields.categoryY = 'name'
          series1.columns.template.propertyFields.fill = 'color' // get color from data
          series1.columns.template.propertyFields.stroke = 'color'
          series1.columns.template.strokeOpacity = 0
          series1.data = data.filter((item: GanttChartData) => item.type === name)

          let valueLabel = series1.bullets.push(new am4charts.LabelBullet())
          valueLabel.label.text = '[font-size:12px bold]{label}'
        } else if (name === 'absences') {
          let series2 = chart.series.push(new am4charts.ColumnSeries())
          series2.name = name
          series2.columns.template.height = am4core.percent(100)
          series2.columns.template.tooltipText = '{name}: [bold]{label}'
          series2.dataFields.openDateX = 'fromDate'
          series2.dataFields.dateX = 'toDate'
          series2.dataFields.categoryY = 'name'
          series2.columns.template.propertyFields.fill = 'color' // get color from data
          series2.columns.template.propertyFields.stroke = 'color'
          series2.columns.template.strokeOpacity = 0
          series2.data = data.filter((item: GanttChartData) => item.type === name)

          let valueLabel = series2.bullets.push(new am4charts.LabelBullet())
          valueLabel.label.text = '[font-size:12px bold]{label}'
        } else if (name === 'calendar') {
          let series3 = chart.series.push(new am4charts.ColumnSeries())
          series3.name = name
          series3.columns.template.height = am4core.percent(100)
          series3.columns.template.tooltipText = '{name}: [bold]{label}'
          series3.dataFields.openDateX = 'fromDate'
          series3.dataFields.dateX = 'toDate'
          series3.dataFields.categoryY = 'name'
          series3.columns.template.propertyFields.fill = 'color' // get color from data
          series3.columns.template.propertyFields.stroke = 'color'
          series3.columns.template.strokeOpacity = 0
          series3.data = data.filter((item: GanttChartData) => item.type === name)

          let valueLabel = series3.bullets.push(new am4charts.LabelBullet())
          valueLabel.label.text = '[font-size:12px bold]{label}'
        }
      }

      createSeries('shift', 'shift')
      createSeries('absences', 'absences')
      createSeries('calendar', 'calendar')

      let cellSize = 30
      chart.events.on('datavalidated', function (ev: any) {

        // Get objects of interest
        let chart = ev.target
        let categoryAxis = chart.yAxes.getIndex(0)

        // Calculate how we need to adjust chart height
        let adjustHeight = chart.data.length * cellSize - categoryAxis.pixelHeight

        // get current chart height
        let targetHeight = chart.pixelHeight + adjustHeight

        // Set it on chart's container
        chart.svgContainer.htmlElement.style.height = targetHeight + 'px'

      })

      this.chart = chart
    }
  },

  mounted () {
    this.createChart()
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }

})
